export { redirectToMicrosoftOAuth } from './microsoft.utils';
